var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { TextInput } from "grommet";
import { IconSvg } from "../../IconSvg";
export var StyledTextInput = styled(TextInput)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  max-width: 406px;\n  line-height: 22px;\n  color: black;\n  width: 100%;\n  border-radius: 5px;\n  padding: 14px 10px 14px 56px;\n  background-color: transparent;\n  font-size: 16px;\n  border: 1px solid #323232;\n  height: 56px;\n  border-color: ",
      ";\n",
    ])),
  function (props) {
    return props.error && "#CA3C3C";
  }
);
export var StyledFormField = styled.label(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  position: relative;\n  margin-bottom: 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 13px;\n\n  letter-spacing: 0.2px;\n\n  color: #000000;\n  opacity: ",
      ";\n  color: ",
      ";\n",
    ])),
  function (props) {
    return props.disabled && "0.5";
  },
  function (props) {
    return props.error && "#CA3C3C";
  }
);
export var StyledIconSvg = styled(IconSvg)(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  position: absolute;\n  top: 38%;\n  left: 20px;\n  color: ",
      ";\n  opacity: ",
      ";\n",
    ])),
  function (props) {
    return props.error && "#CA3C3C";
  },
  function (props) {
    return props.disabled && "0.5";
  }
);
export var StyledBox = styled.div(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]))
);
